import { render, staticRenderFns } from "./AppContextMenuOption.vue?vue&type=template&id=3e5265ec&scoped=true&"
import script from "./AppContextMenuOption.vue?vue&type=script&lang=ts&"
export * from "./AppContextMenuOption.vue?vue&type=script&lang=ts&"
import style0 from "./AppContextMenuOption.vue?vue&type=style&index=0&id=3e5265ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5265ec",
  null
  
)

export default component.exports